import { Map } from 'immutable';

import { ADD, ADD_MULTIPLE, REMOVE } from './constants';
import VolunteerTimeOff from './model';

export type VolunteerTimeOffMap = Map<string, VolunteerTimeOff>;

export const initialState: VolunteerTimeOffMap = Map();

export default (state: VolunteerTimeOffMap = initialState, action: any) => {
  switch (action.type) {
    case ADD:
      return state.set(action.volunteerTimeOff.id, action.volunteerTimeOff);

    case ADD_MULTIPLE:
      return state.merge(action.volunteerTimesOff);

    case REMOVE:
      return state.remove(action.volunteerTimeOff.id);

    default:
      return state;
  }
};
